import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { PaymentMethodConnection } from '../gql-types.generated';
import { getStandardHeaders, getStandardHeadersWithAuth } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const QUERY_PAYMENT_METHODS = gql`
  query paymentMethods($id: String!) {
    paymentMethods(id: $id) {
      nodes {
        id
        createdAt
        createdBy
        status
        type
        updatedAt
        updatedBy
        creditCard {
          cardBrand
          displayName
          expirationMonth
          expirationYear
          lastFour
          recurring
          details {
            type
          }
          cardHolder {
            address {
              city
              country
              line1
              line2
              postalCode
              region
            }
            email
            holderName
            phone {
              countryCode
              number
            }
          }
        }
        paymentBank {
          lastFour
          accountType
          accountHolder {
            holderName
          }
        }
      }
      totalCount
    }
  }
`;

export const queryPaymentMethodByToken = async (
  client: ApolloClient<NormalizedCacheObject>,
  token: string,
  isGuestUser: boolean,
): Promise<PaymentMethodConnection | undefined> => {
  const headers = isGuestUser ? getStandardHeaders() : await getStandardHeadersWithAuth();
  const { data, errors } = await client.query<{ paymentMethods: PaymentMethodConnection }>({
    variables: { id: token },
    query: QUERY_PAYMENT_METHODS,
    context: {
      headers,
    },
  });

  if (errors && errors.length > 0) {
    errors.forEach(error => {
      // Log error details in the console.
      console.error(error);
    });
    // Friendly error to the person.
    throw new Error('An error has occurred during the paymentMethods query.');
  }

  if (data && data.paymentMethods) {
    return data.paymentMethods;
  }

  return undefined;
};
